import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { TransportationGroupSelect, UrgencySelect } from '@views/screens/common';
import { QuoteProductClassSelect } from '@views/screens/Quote/components/selects';
import { Col, Form, Row } from 'antd';

import { routeFileSelector } from '../../../../../utilz/i18n';
import FormInput from '../../../../components/Inputs/FormInput';
import FormRadioGroup from '../../../../components/Inputs/FormRadioGroup';
import FormLabel from '../../../../components/Labels/FormLabel';
import TransportationProviderSelector from '../../../../components/Selectors/AsynchSearch/TransportationProviderSelector';
import ShipmentCreatedBySelector from '../../../../components/Selectors/ShipmentCreatedBySelector';
import TransportationModeSelector from '../../../../components/Selectors/TransportationModeSelector';

const AdditionalQuoteSearchOptions = ({ form }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const createdByType = Form.useWatch('createdByType', form);

  return (
    <Row className="pt-10">
      <Col sm={24} className="mb-16">
        <TransportationProviderSelector
          name="transporterKey"
          form={form}
          showPopupFilter
          margin="mb-16"
          labelForTestId="search-quote"
          initialValues={{ countryCode: 'US' }}
        />
        <TransportationModeSelector name="transportationMode" label={t('translation:default.fields.mode')} editMode />
        <TransportationGroupSelect name="transportationGroup" />
        <UrgencySelect name="urgency" />
        <FormInput name="shipmentNumber" editMode label={t('translation:default.fields.shipmentNumber.label')} />
        <FormInput name="poNumber" label={t('translation:default.fields.poNumber')} editMode margin="m-0" />
      </Col>
      <Col sm={24}>
        <FormLabel>{t('translation:default.fields.createdBy')}</FormLabel>
        <div className="mb-5">
          <FormRadioGroup
            options={[
              {
                label: t('translation:default.fields.userName.label'),
                value: 1,
              },
              {
                label: t('translation:shipment.filter.additionalSearchOptions.createdBy.radioEmail'),
                value: 2,
              },
            ]}
            label={t('translation:default.fields.userName.label')}
            name="createdByType"
          />
        </div>
        <ShipmentCreatedBySelector label="" createdType={createdByType} name="createdBy" mode="multiple" />
        <QuoteProductClassSelect
          name="hazardousClass"
          label={t('translation:getQuote.productDetails.hazardousClass.label')}
          placeholder={t('translation:getQuote.productDetails.hazardousClass.placeholder')}
          margin="m-0"
        />
      </Col>
    </Row>
  );
};

export default AdditionalQuoteSearchOptions;
